<template>
  <div class="scroller" ref="my_scroller">
    <template v-if="type == 'refreshandinfinite'">
      <van-pull-refresh v-model="isRefresh" @refresh="refresh" :disabled="disabled">
        <van-list
          v-model="isLoading"
          :finished="isFinished"
          :finished-text="noDataText"
          @load="infinite"
          :immediate-check="immediateCheck"
        >
          <div slot="default">
            <slot></slot>
          </div>
        </van-list>
      </van-pull-refresh>
    </template>
    <template v-else-if="type == 'infinite'">
      <van-list
        v-model="isLoading"
        :finished="isFinished"
        :finished-text="noDataText"
        @load="infinite"
        :immediate-check="immediateCheck"
      >
        <div slot="default">
          <slot></slot>
        </div>
      </van-list>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'refreshandinfinite'
    },
    isRefreshData: {
      type: Boolean,
      default: false
    },
    isLoadingData: {
      type: Boolean,
      default: false
    },
    isFinishedData: {
      type: Boolean,
      default: false
    },
    noDataTextData: {
      type: String,
      default: ''
    },
    isDisabledData: {
      type: Boolean,
      default: false
    },
    immediateCheck: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isRefresh: this.isRefreshData,
      isLoading: this.isLoadingData,
      isFinished: this.isFinishedData,
      noDataText: this.noDataTextData,
      disabled: this.isDisabledData
    }
  },
  watch: {
    isRefreshData(n) {
      this.isRefresh = n
    },
    isLoadingData(n) {
      this.isLoading = n
    },
    isFinishedData(n) {
      this.isFinished = n
    },
    isDisabledData(n) {
      this.disabled = n
    }
  },
  methods: {
    infinite(infinite) {
      this.$emit('on-infinite', infinite)
    },
    refresh(refresh) {
      this.$emit('on-refresh', refresh)
    },
    clickItem() {
      var wrapperScrollTop
      if (document.getElementById('cup')) {
        wrapperScrollTop = document.getElementById('cup').scrollTop
      } else {
        wrapperScrollTop =
          parseInt(document.body.scrollTop) || parseInt(document.documentElement.scrollTop)
      }
      // console.log('wrapperScrollTop', wrapperScrollTop)
      return wrapperScrollTop
    }
  }
}
</script>

<style scoped lang="scss">
.scroller {
  .van-pull-refresh {
    overflow: visible;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Scroller.vue